<template>
  <div>
    <Table
      :data="props.search.results"
      :config="config"
      noContentMessage="No search results yet."
    ></Table>
  </div>
</template>

<script setup lang="ts">
import Table from "~/components/Table.vue";
import type { Org, Profile, Search, SearchResult } from "~/common/types/types";
import ellipsize from "ellipsize";

const props = defineProps({
  search: {
    type: Object as PropType<Search>,
    required: true,
  },
});

const mappings = {
  _id: { column: false },
  orgId: { column: false },
  description: {column: false },
  distance: {
    column: "Score",
      cell: (r: SearchResult) => {
      return `${(r.distance * 100).toFixed(0)}%`;
    }
  },
  // parentId: {
  //   column: "Parent",
  //   cell: (profile: Profile) => {
  //     if (!profile.parentId) return;
  //     const parentProfile = store.getProfile(profile.parentId);
  //     return parentProfile.name;
  //   },
  // },
  // scheduledDate: {
  //   order: 1,
  //   column: "Scheduled",
  //   cell: (profile: Profile) =>
  //     `${moment(profile.scheduledDate).format("YYYY-MM-DD")}`,
  // },
};

const actions = [
  {
    title: "Open",
    type: "open",
    to: (item: Profile) => ({
      path: `/profiles/${item._id}`,
    }),
  },
  
];

const config = {
  mappings: mappings,
  actions: actions,
};
</script>
